export var PredefinedSource;
(function (PredefinedSource) {
    PredefinedSource["None"] = "'none'";
    PredefinedSource["ReportSample"] = "'report-sample'";
    PredefinedSource["Self"] = "'self'";
    PredefinedSource["StrictDynamic"] = "'strict-dynamic'";
    PredefinedSource["UnsafeEval"] = "'unsafe-eval'";
    PredefinedSource["UnsafeInline"] = "'unsafe-inline'";
})(PredefinedSource || (PredefinedSource = {}));
export var SchemaSource;
(function (SchemaSource) {
    SchemaSource["Blob"] = "blob:";
    SchemaSource["Data"] = "data:";
    SchemaSource["Filesystem"] = "filesystem:";
    SchemaSource["Http"] = "http:";
    SchemaSource["Https"] = "https:";
    SchemaSource["MediaStream"] = "mediastream:";
})(SchemaSource || (SchemaSource = {}));
export var DirectiveType;
(function (DirectiveType) {
    DirectiveType["Fetch"] = "fetch";
    DirectiveType["Document"] = "document";
    DirectiveType["Navigation"] = "navigation";
    DirectiveType["Reporting"] = "reporting";
    DirectiveType["Other"] = "other";
})(DirectiveType || (DirectiveType = {}));
